import React, { useState } from 'react';
import s from './s.module.less';
import useProviderOverview from 'hooks/useProviderOverview';
import { Avatar, Button, Modal } from 'antd';
import { isDevEnv, isTestEnv } from 'utils/common';
import { EyeOutlined } from '@ant-design/icons';

const KlarityDomain = isDevEnv() ? 'https://dev.d2ysjydukc4efk.amplifyapp.com' : isTestEnv() ? 'https://test.d2ysjydukc4efk.amplifyapp.com' : 'https://helloklarity.com';

const ProfileCard = () => {
    const [provider] = useProviderOverview();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handlePreview = () => {
        setIsModalOpen(true);
    };

    const insuranceLabel = provider.insurances && provider.insurances.length > 0 ? provider.insurances.slice(0, provider.insurances.length - 1).join(', ') + (provider.insurances.length > 1 ? ' and ' : '') + provider.insurances[provider.insurances.length - 1] : '';

    const previewUrl = `${KlarityDomain}/provider/${provider.providerNameSlug}?isPreview=true&id=${provider.providerId}`;

    return <div className={s.wrap}>
        <div className="flex gap-4">
            <Avatar src={provider.photo} size={80} />
            <div>
                <div className="text-lg font-medium">{provider.firstName} {provider.lastName}</div>
                <div>{provider.credential}</div>
                {insuranceLabel && <div className="flex items-center gap-1 text-sm text-gray-500">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                        <path d="M6.46824 0.963739L11.1349 2.71374C11.3891 2.80903 11.6082 2.97964 11.7628 3.20278C11.9174 3.42591 12.0003 3.69093 12.0002 3.96241V7.53774C12.0003 8.65202 11.69 9.7443 11.1042 10.6922C10.5184 11.6401 9.68022 12.4061 8.68358 12.9044L6.44758 14.0217C6.30869 14.0912 6.15554 14.1274 6.00025 14.1274C5.84495 14.1274 5.6918 14.0912 5.55291 14.0217L3.31691 12.9037C2.32027 12.4054 1.48209 11.6394 0.89629 10.6915C0.310492 9.74363 0.000220369 8.65136 0.000244401 7.53707V3.96307C7.48009e-05 3.69148 0.0828478 3.42632 0.23749 3.20305C0.392132 2.97978 0.611267 2.80907 0.865578 2.71374L5.53225 0.963739C5.83399 0.850629 6.1665 0.850629 6.46824 0.963739ZM6.00025 4.83374C5.83696 4.83376 5.67935 4.89371 5.55733 5.00222C5.43531 5.11072 5.35735 5.26024 5.33824 5.42241L5.33358 5.50041V6.83374H4.00025C3.83033 6.83393 3.66689 6.89899 3.54333 7.01564C3.41978 7.13228 3.34542 7.29171 3.33546 7.46134C3.32551 7.63096 3.38069 7.79799 3.48975 7.92829C3.59881 8.0586 3.75351 8.14234 3.92225 8.16241L4.00025 8.16707H5.33358V9.50041C5.33377 9.67033 5.39883 9.83376 5.51548 9.95732C5.63212 10.0809 5.79155 10.1552 5.96117 10.1652C6.1308 10.1751 6.29783 10.12 6.42813 10.0109C6.55844 9.90184 6.64218 9.74714 6.66224 9.57841L6.66691 9.50041V8.16707H8.00025C8.17017 8.16688 8.3336 8.10182 8.45716 7.98517C8.58072 7.86853 8.65507 7.7091 8.66503 7.53948C8.67498 7.36985 8.6198 7.20282 8.51074 7.07252C8.40168 6.94222 8.24697 6.85847 8.07825 6.83841L8.00025 6.83374H6.66691V5.50041C6.66691 5.32359 6.59667 5.15403 6.47165 5.029C6.34662 4.90398 6.17706 4.83374 6.00025 4.83374Z" fill="#34D399" />
                    </svg>
                    Accepts {insuranceLabel}
                </div>}
            </div>
        </div>
        <Button onClick={handlePreview} className="previewBtn"><EyeOutlined />Preview as patient</Button>
        <Modal
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            title="Klarity profile"
            footer={null}
            width={800}
        >
            <iframe src={previewUrl} className={s.iframe} />
        </Modal>
    </div>;
};

export default ProfileCard;
